class SearchLoadMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector('button');
    this.grid = document.querySelector('#search-results');
    this.observer = null;

    if (!this.button || !this.grid) {
      return;
    }

    // Check if we are in infinite scroll mode
    if (this.dataset.scroll === 'true') {
      this.initIntersectionObserver();
    } else {
      this.button.addEventListener('click', this.loadMore.bind(this));
    }
  }

  initIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px 0px 400px 0px',
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.button.classList.contains('loading')) {
          this.loadMore();
        }
      });
    }, options);

    this.observer.observe(this.button);
  }

  async loadMore() {
    this.button.setAttribute('disabled', true);
    this.button.classList.add('loading');

    const nextUrl = this.button.dataset.href;

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error('Network response was not ok');
      
      const text = await response.text();
      const parser = new DOMParser();
      const html = parser.parseFromString(text, 'text/html');

      // Find all result items (product-card, article-card, page-card)
      const newItems = Array.from(html.querySelectorAll('#search-results > *:not(search-load-more)'));

      // Find the next button from the response
      const nextButton = html.querySelector('.load-more-btn');
      const nextHref = nextButton ? nextButton.dataset.href : null;

      // Append new items to the grid
      newItems.forEach(item => {
        this.grid.insertBefore(item, this);
      });

      // Update button for next page
      if (nextHref) {
        this.button.dataset.href = nextHref;
        this.button.removeAttribute('disabled');
        this.button.classList.remove('loading');
      } else {
      // No more pages
      if (this.observer) this.observer.disconnect();
      this.remove();
    }

    } catch (error) {
      console.error('Error loading results:', error);
      this.button.removeAttribute('disabled');
      this.button.classList.remove('loading');
    }
  }
}

if (!customElements.get('search-load-more')) {
  customElements.define('search-load-more', SearchLoadMore);
}
